import { Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { HorizontalMenuItemsKey } from "./HorizontalMenu.default";

export interface HorizontalMenuProps {
  onMenuSelect: (key: string) => void;
}

const items = [
  {
    key: HorizontalMenuItemsKey.Dashboard,
    label: "HOME",
  },
  {
    key: HorizontalMenuItemsKey.Profile,
    label: "COMPANY PROFILE",
  },
  {
    key: HorizontalMenuItemsKey.Processes,
    label: "KEY PROCESSES",
  },
  {
    key: HorizontalMenuItemsKey.Policies,
    label: "COMPANY POLICIES",
  },
  {
    key: HorizontalMenuItemsKey.Incidents,
    label: "INCIDENTS",
  },
  {
    key: HorizontalMenuItemsKey.Actions,
    label: "ACTIONS",
  },
  {
    key: HorizontalMenuItemsKey.WellBeing,
    label: "WELL-BEING CORNER",
  },
  {
    key: HorizontalMenuItemsKey.Notifications,
    label: "NOTIFICATIONS",
  },
  {
    key: HorizontalMenuItemsKey.Contact,
    label: "CONTACT",
  },
];

function HorizontalMenu({ onMenuSelect }: HorizontalMenuProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [current, setCurrent] = useState("home");

  useEffect(() => {
    const getCurrentPath = () => location.pathname.split("/")[1] || "home";
    const path = getCurrentPath();
    if (path !== current) {
      setCurrent(path);
      onMenuSelect(path);
    }
  }, [location, onMenuSelect, current]);

  const onClick = (e: { key: string }) => {
    setCurrent(e.key);
    onMenuSelect(e.key);

    switch (e.key) {
      case HorizontalMenuItemsKey.Dashboard:
        navigate("/home");
        break;
      case HorizontalMenuItemsKey.Profile:
        navigate("/profile");
        break;
      case HorizontalMenuItemsKey.Processes:
        navigate("/processes/overview");
        break;
      case HorizontalMenuItemsKey.Policies:
        navigate("/policies");
        break;
      case HorizontalMenuItemsKey.Incidents:
        navigate("/incidents");
        break;
      case HorizontalMenuItemsKey.Actions:
        navigate("/actions/overview");
        break;
      case HorizontalMenuItemsKey.WellBeing:
        navigate("/well-being");
        break;
      case HorizontalMenuItemsKey.Notifications:
        navigate("/notifications");
        break;
      case HorizontalMenuItemsKey.Contact:
        navigate("/contact");
        break;
    }
  };

  return (
    <Menu
      className="border-none bg-transparent"
      onClick={onClick}
      selectedKeys={[current]}
      mode="horizontal"
      items={items}
    />
  );
}

export default HorizontalMenu;
